import { UntilDestroy } from '@ngneat/until-destroy';
import { EventEmitter, Injectable } from '@angular/core';
import { JFSEService } from '@services/jfse';
import { catchError, tap } from 'rxjs/operators';
import { of } from 'rxjs';

@UntilDestroy()
@Injectable({
    providedIn: 'root',
})
export class JfseIframeEventManagerService {
    constructor(private readonly jfseService: JFSEService) {}

    treatIframeResult(
        message: any,
        runRes: EventEmitter<any>,
        runError: EventEmitter<any>,
    ) {
        try {
            const messageData = JSON.parse(atob(message.data));
            this.routeEvent(messageData, runRes, runError);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.info(
                `EVENT data cannot be parsed: ${e.message}, content: ${
                    message?.data instanceof Object
                        ? JSON.stringify(message.data)
                        : message.data
                }`,
            );
        }
    }

    routeEvent(
        messageData: any,
        runRes: EventEmitter<any>,
        runError: EventEmitter<any>,
    ) {
        switch (messageData?.method?.name) {
            case 'FDS-gui':
                this.treatBillcreation(messageData, runRes, runError);
                break;
            case 'DVF-gui-choix/beneficiaire':
                this.treatCvDatas(messageData, runRes, runError);
                break;
            default:
                // eslint-disable-next-line no-console
                console.info('Unrecognized event', messageData);
                runError.emit('errors.jfse.EVENT_NOT_IMPLEMENTED');
        }
    }

    private treatBillcreation(
        messageData: any,
        runRes: EventEmitter<any>,
        runError: EventEmitter<any>,
    ) {
        messageData.method.output.facture.externalData = JSON.parse(
            messageData?.method?.output?.facture?.externalData,
        );

        this.jfseService
            .markAsValidated(
                messageData.method.output.facture.externalData,
                messageData.method.output.facture.keyFacture,
                messageData.method.output.facture.numeroFacture,
            )
            .pipe(
                tap(() => {
                    runRes.emit('billing.jfse.mark-as-validated');
                }),
                catchError((err) => {
                    runError.emit(err);
                    return of();
                }),
            )
            .subscribe();
    }

    private treatCvDatas(
        messageData: any,
        runRes: EventEmitter<any>,
        runError: EventEmitter<any>,
    ) {
        if (messageData?.method?.output?.selection >= 0) {
            runRes.emit(messageData?.method?.output?.selection);
            return;
        }
        runError.emit('errors.jfse.UNABLE_TO_SELECT_BENEFICIARY');
    }
}
